module.exports = __webpack_public_path__ + "img/1585493760.aae12f50.jpg";